import { loadUserDetails } from "./auth";
import "./index.css";
import "./assests/css/styles.css";
import "font-awesome/css/font-awesome.min.css";
import "./components/HeaderComponent/navBar.css";
import "./i18n";
import { authContext, loginRequest } from "./adalConfig";
import "core-js";
import { InteractionRequiredAuthError } from "@azure/msal-browser";

new Promise(async(resolve, reject) => {
  await authContext.handleRedirectPromise().then(
    async () => {
      const accounts = await authContext.getAllAccounts();
      console.log("[MSAL] Accounts found:", accounts);
      const currentAccount = accounts[0];
      const silentAccessTokenRequest = {
        scopes: loginRequest.scopes,
        account: currentAccount,
        forceRefresh: false,
      };

      let accessToken = null;
      if (accounts.length === 0) {
        console.log("[MSAL] No accounts found. Redirecting to login...");
        await authContext.loginRedirect(loginRequest).then(
          () => {
            loadUserDetails(accessToken, currentAccount);
            resolve();
          },
          (err) => {
            reject(err);
            console.error("error in " + err);
          },
        );
      } else {
        try {
          console.log("[MSAL] Attempting silent token acquisition...");
          accessToken = await authContext
            .acquireTokenSilent(silentAccessTokenRequest)
            .then((accessTokenResponse) => {
              console.log("[MSAL] Silent token acquired successfully.");
              return accessTokenResponse.accessToken;
            });
        } catch (err) {
          if (err instanceof InteractionRequiredAuthError) {
            console.warn("[MSAL] Interaction required for token. Redirecting...");
            return authContext.loginRedirect(loginRequest);
          } else {
            console.error("[MSAL] Silent token acquisition failed:", err);
            return reject(err);
          }
        }

        loadUserDetails(accessToken, currentAccount);
        resolve();
      }
    },
    (err) => {
      reject(err);
      console.error("error " + err);
    },
  );
});
